module.exports = __webpack_public_path__ + "static/basic-goods-8dde8361e20cd40f7f9266c65076374a.png";